function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-970.000000, -325.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(854.000000, 325.000000)"
}, React.createElement("g", {
  transform: "translate(116.000000, 0.000000)"
}, React.createElement("path", {
  d: "M42.546581,25.0383431 L57.7365837,50.5253751 C58.0193316,50.9997927 57.8639526,51.6135967 57.389535,51.8963446 C57.2347062,51.9886209 57.0578158,52.0373355 56.8775746,52.0373355 L26.4975693,52.0373355 C25.9452845,52.0373355 25.4975693,51.5896202 25.4975693,51.0373355 C25.4975693,50.8570943 25.5462839,50.6802039 25.6385602,50.5253751 L40.8285629,25.0383431 C41.1113108,24.5639255 41.7251147,24.4085465 42.1995323,24.6912944 C42.3422485,24.7763518 42.4615237,24.895627 42.546581,25.0383431 Z",
  transform: "translate(41.687649, 38.293743) rotate(90.000000) translate(-41.687649, -38.293743) "
}), React.createElement("path", {
  d: "M37,70.7111111 C55.6181326,70.7111111 70.7111111,55.6181326 70.7111111,37 C70.7111111,18.3818674 55.6181326,3.28888889 37,3.28888889 C18.3818674,3.28888889 3.28888889,18.3818674 3.28888889,37 C3.28888889,55.6181326 18.3818674,70.7111111 37,70.7111111 Z M37,74 C16.5654643,74 0,57.4345357 0,37 C0,16.5654643 16.5654643,0 37,0 C57.4345357,0 74,16.5654643 74,37 C74,57.4345357 57.4345357,74 37,74 Z"
})))));

const SvgPlayIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "74px",
  height: "74px",
  viewBox: "0 0 74 74",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPlayIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play-icon.e2892af4.svg";
export { ForwardRef as ReactComponent };